import styled from 'styled-components';

export const LeftBgItem = styled.div`
  width: 94px;
  height: 189px;
  bottom: 0px;
  left: -1px;
  position: absolute;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const RightBgItem = styled.div`
  width: 262px;
  height: 219px;
  top: -14.19px;
  right: -24px;
  position: absolute;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const BrokerCompanyCardsContainer = styled.div`
  margin: 0 auto;
  max-width: 1212px;
  padding: 60px 30px;
`;
